import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material'
import { Subject } from 'rxjs'
import { debounceTime } from 'rxjs/operators'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { InstructionService, AppService, DialogService } from '../../../../../services'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'

const KEY = 'etapeinstruction-dialog'

@Component({
  selector: 'atyl-etapeinstruction',
  templateUrl: './etapeinstruction.component.html',
  styleUrls: ['./etapeinstruction.component.scss']
})
@Stringable({
  path: 'views/partials/layout/dialogs/etapeinstruction-dialog',
  key: KEY,
})
export class EtapeinstructionComponent extends BaseDialogComponent implements OnInit {

  @StringableValues(KEY)
  strings: any
  instruction: any
  iddossier: any
  selectedInstructeur: any
  title: any
  comment: any
  private debounce: Subject<string> = new Subject();
  selectedDemandeType: any
  etapes: any;
  
  constructor(
    public dialogRef: MatDialogRef<EtapeinstructionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appService: AppService,
    private instructionService: InstructionService,
    changeDetectorRef: ChangeDetectorRef,
    dialogService: DialogService
   
  ) {
    super(dialogRef, dialogService, changeDetectorRef)
  }

  ngOnInit() {
    this.instruction = this.data.instruction

    if (this.instruction && this.instruction.comment)
      this.comment = this.instruction.comment
    if (this.instruction && this.instruction.titre)
      this.title = this.instruction.titre;
    this.etapes = this.instruction.transitions;
    if (this.data.recoverTransitions)
      this.etapes = this.data.recoverTransitions ? this.data.recoverTransitions : [];
    this.iddossier = this.data.iddossier
    if (this.instruction.type && this.instruction.type.professions && this.data.iddossier) {
      let professions = []
      this.instruction.type.professions.forEach(element => {
        professions.push(element.key)
      })
      this.appService.getUsersByProfressions(professions, this.iddossier).subscribe((res) => {
        this.instruction.possibleTiers = res.result
        if (this.instruction && this.instruction.possibleTiers) {
          this.instruction.possibleTiers.forEach(element => {
            if (this.instruction.instructeur.ID === element.ID)
              this.instruction.selectedTier = element
          })
        }
        this.changeDetectorRef.detectChanges()
      })

      this.debounce.pipe(
        debounceTime(1000)
      ).subscribe(search => {
        if (search.length > 0) {
          this.appService.getUsersByProfressions(professions, this.iddossier, search).subscribe((result) => {
            this.instruction.possibleTiers = result.result
            this.changeDetectorRef.detectChanges()
          })
        }

      })
      if (this.instruction) {
        let _steps=[];
        if (this.instruction.transitions
        
        ) {
           for(let i=0;i<this.instruction.transitions.length;i++) {
                _steps.push(this.instruction.transitions[i].to.ID);
               // this.instruction.transitions[i].demandes=[];
               this.instruction.transitions[i].disabled=true;
            }
        }
        let _options={
            steps:_steps
        }
        console.log("transitions",this.instruction.ID,_options)
        this.instructionService.transitions(this.instruction.ID,_options).subscribe((result: JSONRpcResponse) => {
             console.log("transitions result",result.result) 
             if (this.instruction.transitions ) {
                for(let i=0;i<this.instruction.transitions.length;i++) {
                    if (result.result[this.instruction.transitions[i].to.ID]!=undefined 
                    && Array.isArray(result.result[this.instruction.transitions[i].to.ID]))
                       this.instruction.transitions[i].demandes=result.result[this.instruction.transitions[i].to.ID][0];
                   
                    this.instruction.transitions[i].disabled=false;
                    
                }
                this.changeDetectorRef.detectChanges()
               } 
             
           }
        )
      }
    }
  }


  displayAutoSelectListInstru(key?: any): string | undefined {
    let selected
    if (this.instruction && this.instruction.possibleTiers) {
      this.instruction.possibleTiers.forEach((select) => {
        if (key && select.ID === key.ID)
          selected = select
      })
    }
    return selected ? selected.NOM + ' ' + (selected.PRENOM ? selected.PRENOM : '') : undefined
  }

  triggerAutocompSelectionList(search: any) {
    this.debounce.next(search)
  }

  changeEtape(etape: any) {
    if (this.instruction && this.instruction.selectedTier && !this.selectedInstructeur) {
      this.selectedInstructeur = this.instruction.selectedTier
    }
    
    let dataReturn = {
      instructeur: this.selectedInstructeur,
      transition_demande_type: null,
      titre: this.title,
      comment: this.comment,
      etape: etape
    }

    let close=true;
    if(etape.demandes!=undefined && etape.demandes && etape.demandes.demande_type &&
      etape.demandes.demande_type.length>0
    ) {
        if (!this.selectedDemandeType)
          close=false;
        else
            dataReturn.transition_demande_type=this.selectedDemandeType
    }
    console.log("changeEtape",close,dataReturn,etape)
    if (close)
        this.dialogRef.close(dataReturn)
  }
}
